/**
 * PDF e imagens das folhas, com o mesmo exportador das outras telas do
 * Legado (html2canvas + jsPDF, no navegador; decisão do Igor, 22/10). Cada
 * folha é capturada da área de impressão em escala 1:1, então o arquivo sai
 * igual ao papel. Os avisos de tela não aparecem: a área de impressão não
 * recebe o contorno das células.
 */
import { captureWithExpand } from "../../utils/exportacao/captureWithExpand";
import { aguardarFontes } from "./folha/fontes";
import { escaparSeletor } from "./seletor";

const ESCALA_DA_CAPTURA = 2;
const QUALIDADE_JPG = 0.92;
const A4 = { largura: 297, altura: 210 };

function elementoDaFolha(chave) {
  const elemento = document.querySelector(`[data-area-impressao] [data-folha="${escaparSeletor(chave)}"]`);
  if (!elemento) throw new Error("A folha não está pronta para exportar. Tente de novo.");
  return elemento;
}

async function capturar(folha) {
  return captureWithExpand(elementoDaFolha(folha.chave), { scale: ESCALA_DA_CAPTURA, backgroundColor: "#ffffff" });
}

function orientacao(folha) {
  return folha.setor.retrato ? "portrait" : "landscape";
}

export async function gerarPdfDasFolhas(folhas, nomeDoArquivo) {
  if (!folhas.length) throw new Error("Nenhuma folha selecionada.");
  await aguardarFontes();
  // jsPDF só carrega quando alguém exporta: fica fora do pacote da tela.
  const { jsPDF } = await import("jspdf");
  let documento = null;
  for (const folha of folhas) {
    // Uma folha por vez: 20 folhas em paralelo estouram a memória do celular.
    // eslint-disable-next-line no-await-in-loop
    const canvas = await capturar(folha);
    const deitada = orientacao(folha) === "landscape";
    const largura = deitada ? A4.largura : A4.altura;
    const altura = deitada ? A4.altura : A4.largura;
    if (!documento) documento = new jsPDF({ orientation: orientacao(folha), unit: "mm", format: "a4", compress: true });
    else documento.addPage("a4", orientacao(folha));
    documento.addImage(canvas.toDataURL("image/jpeg", QUALIDADE_JPG), "JPEG", 0, 0, largura, altura, undefined, "FAST");
  }
  documento.save(nomeDoArquivo);
}

function baixar(url, nome) {
  const link = document.createElement("a");
  link.href = url;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

/** Uma imagem por folha (PNG ou JPG). */
export async function salvarImagensDasFolhas(folhas, formato, nomePorFolha) {
  if (!folhas.length) throw new Error("Nenhuma folha selecionada.");
  await aguardarFontes();
  const mime = formato === "jpg" ? "image/jpeg" : "image/png";
  for (const folha of folhas) {
    // eslint-disable-next-line no-await-in-loop
    const canvas = await capturar(folha);
    baixar(canvas.toDataURL(mime, QUALIDADE_JPG), nomePorFolha(folha));
  }
}
